import {
  GET_ALL_BOOKINGS_VALUE,
  GET_ALL_BOOKING_BY_COMPANY_ID,
  CHECK_PLAN,
  GET_BOOKING_FIELD_LIST,
  RESET_REDUX_STATE
} from "../constants";

const initState = {
  bookingList: [],
  bookingValue: "",
  planDetail: '',
  bookingFieldList: []
};

const booking = (state = { initState }, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_BOOKING_BY_COMPANY_ID: {
      return {
        ...state,
        bookingList: payload,
      };
    }
    case GET_ALL_BOOKINGS_VALUE: {
      return {
        ...state,
        bookingValue: payload,
      };
    }

    case GET_BOOKING_FIELD_LIST: {
      return {
        ...state,
        bookingFieldList: payload
      }
    }

    case CHECK_PLAN : {
      return {
        ...state,
        planDetail: payload
      }
    }
    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default booking;
